class MFRStickyElements {
    constructor( i, e ) {
        this.$index = i
        this.$element = $( e )

        this.selectors = {
          stickyWrapper: '.mfr-sticky-wrapper',
          stickyElement: '.mfr-sticky-element'
        }

        this.init()
    }

    init() {
      this.$stickyWrapper = this.$element.find(this.selectors.stickyWrapper)
      this.$stickyElement = this.$element.find(this.selectors.stickyElement)

      this.initSticky()
    }

    initSticky() {
      const element = this.$stickyElement;
      const stickyElement = this.$stickyWrapper;
      let sticky;

      function create() {
        const endTrigger = $(stickyElement).outerHeight() - element.outerHeight()

        sticky = ScrollTrigger.create({
          trigger: element,
          start: `top top+=${$('header.header').height()}`,
          end: `+=${endTrigger}`,
          pin: true, // pin the element
          pinSpacing: false,
        });
      }

      window.addEventListener('load', () => {
        create();
      });

      $(window).on("resize", function() {
        if ($(window).width() < 768) {
          sticky.kill();
        } else {
          sticky.kill();
          create();
        }
      });
    }
  }